import React from "react";
import { PageHeader } from "../../../common";
import ManageArticles from "./ManageArticles";
import ManageTickets from "./ManageTickets";
import { Button } from "../../../common";
import { Plus } from "lucide-react";
import { useHasPermission } from "../../../../store/hooks/useRbac";
import { PERMISSIONS } from "../../../../utils/rbac/permissions";

const HelpCenterAdminMain: React.FC = () => {
  const canManage = useHasPermission(PERMISSIONS.HELP_CENTER_ADMIN_MANAGE || "HELP_CENTER_ADMIN_VIEW");

  return (
    <div className="w-full">
      <PageHeader
        title="Help Center Management"
        description="Publish help articles and resolve employee feedback tickets."
        breadcrumbs={[{ label: "Home", path: "/dashboard" }, { label: "Help Center Management" }]}
        actions={
          canManage ? (
            <Button
              appearance="primary"
              size="middle"
              onClick={() => {
                window.dispatchEvent(new CustomEvent('open-article-modal'));
              }}
              icon={<Plus className="w-4 h-4" />}
            >
              Add Article
            </Button>
          ) : undefined
        }
      />

      {/* Figma single page: articles table with pagination, feedback panel below */}
      <div className="mb-5 sm:mb-6">
        <ManageArticles />
      </div>
      <ManageTickets />
    </div>
  );
};

export default HelpCenterAdminMain;
